import React, { useContext, useState } from 'react';
import { Logout, ToastMessage } from '../../../../utils/Helper';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import Breadcrumb from '../../../../reuseable/Breadcrumb/Breadcrumb';
import { REPAIRING, REPAIRING_LIST, SLACE } from '../../../../reuseable/Breadcrumb/BreadcrumbConstant';
import { get_Deal_Of_The_Day } from '../../../../Apis/dealOfTheDayApi/DealOfTheDayApi';
import RepairingTableContainer from './RepairingDataTabelContainer';
import RepairingContext from '../../../../context/RepairingContext/RepairingContext';
import { getRepairOrder } from '../../../../Apis/repairingApi/RepairingApi';
import { REPAIRING_PAYMENT } from '../../../../constants';
import RepairPayment from './RepairPayment';
import Modal from '../../../../reuseableComponents/Modal';
import { useRef } from 'react';
import moment from 'moment';

const RepairingList = () => {
   const {
      //pagination state variables
      pageSize,
      page,
      setRecord,
      sortOrder,
      sortBy,
      filter,
      setFilter,
      paymentModal,
      setPaymentModal
   } = useContext(RepairingContext);
   const [dates, setDates] = useState([]);
   const barcodeRef = useRef(null);
   const history = useNavigate();

   /**
    * get repairing List
    */

   let paramsObj = {
      pageNumber: page,
      recordsPerPage: pageSize,
      sortOrder,
      sortBy
   };

   if (filter) {
      paramsObj['search'] = { productName: filter };
   }
   if (dates?.length === 2 && dates && dates !== null && dates !== undefined && dates[1]) {
      paramsObj['search'] = {
         ...paramsObj.search,
         startDate: moment(dates[0]).format(),
         endDate: moment(dates[1]).format()
      };
   }

   let { data, refetch, isLoading, error } = useQuery(
      ['getRepairOrder', paramsObj],
      async () => await getRepairOrder(paramsObj),
      {
         onSuccess: (response) => {
            if (response.status === 200) {
               setRecord(response.pager.totalRecords);
            }
         },
         refetchOnWindowFocus: false,
         keepPreviousData: true
      }
   );

   if (error) {
      const { status, message } = error?.response?.data || error;
      ToastMessage(status, message);
      Logout(history, status);
   }
   /**
    * Open Popup and Close Popup
    */
   const handleOpenandClosePopup = (condition) => {
      if (condition) {
         setPaymentModal(condition);
      } else {
         setPaymentModal(condition);
      }
   };
   const removeFilter = () => {
      setDates(null);
      setFilter('');
   };
   return (
      <>
         <Breadcrumb name={REPAIRING} slace={SLACE} name1={REPAIRING_LIST} />
         <div className='d-none'>
            <svg ref={barcodeRef}></svg>
         </div>
         <div id='paymentReceipt'></div>
         <RepairingTableContainer
            isLoading={isLoading}
            data={data}
            refetch={refetch}
            dates={dates}
            setDates={setDates}
            removeFilter={removeFilter}
         />
         <Modal
            hide={handleOpenandClosePopup}
            visible={paymentModal}
            header={REPAIRING_PAYMENT}
            Component={<RepairPayment barcodeRef={barcodeRef} />}
         />
      </>
   );
};

export default RepairingList;
